/**
 * Middleware protecting ident routes.
 */

const redirectPattern = /^(profile-signature-standards|direct-sign-identification)-(eidas|zertes|legislation|update).*$/

export default defineNuxtRouteMiddleware(async to => {
  const targetRouteName = to.name ? String(to.name) : null

  if (!targetRouteName || redirectPattern.test(targetRouteName)) {
    const ident = useIdentStore()
    const { eidasOngoingIdent, zertesOngoingIdent } = storeToRefs(ident)
    await Promise.all([ident.eidasGetAllIdentInfo(), ident.zertesGetAllIdentInfo()])
    // If there is already an identification in process,
    // redirect to the signature standards page
    if (eidasOngoingIdent.value || zertesOngoingIdent.value) {
      const { directSignSession } = storeToRefs(useDirectSignStore())

      if (directSignSession.value)
        return navigateTo({
          name: 'direct-sign-identification-id-userid',
          params: {
            id: directSignSession.value.auth.password,
            userid: directSignSession.value.auth.username,
          },
        })
      return navigateTo({ name: 'profile-signature-standards' })
    }
  }
})
